import React from 'react';
import { Helmet } from 'react-helmet-async';

function PrivacyPolicy() {
    return (
        <div className="bg-white p-8 md:p-12 rounded-lg shadow-lg max-w-4xl mx-auto my-10">
            <Helmet>
                <title>Privacy Policy | Health Portal</title>
            </Helmet>
            <h1 className="text-3xl font-bold text-brand-secondary mb-6">Privacy Policy</h1>
            <p className="mb-4 text-gray-600">Last updated: March 2025 | Operated by Smart City Ajmer (operating as Search is End!)</p>

            <div className="space-y-6 text-gray-700">
                <section>
                    <h2 className="text-xl font-semibold text-brand-primary mb-2">1. Information We Collect</h2>
                    <p>We collect personal and medical information that you voluntarily provide to us when you register for a Health Card. This includes your name, contact details, date of birth, blood group, allergies, medical conditions, and emergency contact information.</p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-brand-primary mb-2">2. How We Use Your Information</h2>
                    <p>Your information is used to create your digital Health Card profile. This profile is intended to be accessed by medical personnel or first responders in the event of an emergency by scanning your unique QR code.</p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-brand-primary mb-2">3. Data Security</h2>
                    <p>We implement relevant security measures, including encryption and strict access controls, to protect your sensitive health data against unauthorized access, alteration, or disclosure.</p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-brand-primary mb-2">4. Sharing of Information</h2>
                    <p>We do not sell your personal data to third parties. Your profile is accessible via your secure URL/QR code. Limited data may be shared with trusted third-party service providers (such as Razorpay for payment processing) strictly for operational purposes.</p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-brand-primary mb-2">5. Your Rights</h2>
                    <p>You have the right to access, modify, or delete your personal information at any time by logging into your dashboard or contacting our support team.</p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-brand-primary mb-2">6. Jurisdiction</h2>
                    <p>This Privacy Policy is governed by the laws applicable to our head office. In the event of any court case or legal dispute, the courts in Ajmer (our main head office city) will have exclusive jurisdiction.</p>
                </section>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
